import React from 'react';
import Typography from '@primitives/Typography';
import CheckOutlineIcon from '@icons/CheckOutlineIcon';
import DashIcon from '@icons/DashIcon';
import { CheckboxProps } from './types';
import styles from './Checkbox.module.scss';
import cx from 'classnames';

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    (
        {
            disabled = false,
            title,
            subTitle,
            className,
            checkboxOuterWrapperClass = '',
            checkboxClass = '',
            checkboxTitleClass = '',
            customTemplate,
            ...restProps
        },
        ref,
    ) => {
        return (
            <div
                className={cx(
                    styles['checkbox-outer-wrapper'],
                    {
                        [styles['disabled']]: disabled,
                    },
                    checkboxOuterWrapperClass,
                )}
            >
                <label className={styles['checkbox-inner-wrapper']}>
                    <input type="checkbox" ref={ref} disabled={disabled} {...restProps} />
                    <div className={cx(styles['checkbox'], checkboxClass)}>
                        <CheckOutlineIcon
                            width={8}
                            height={8}
                            className={styles['checkbox--checkIcon']}
                            color={styles.naviCheckboxDefaultIconColor}
                        />
                        <DashIcon
                            width={8}
                            height={8}
                            className={styles['checkbox--indeterminateIcon']}
                            color={styles.naviCheckboxDefaultIconColor}
                        />
                    </div>
                    {customTemplate
                        ? customTemplate
                        : title && (
                              <div className={styles['label']}>
                                  <Typography
                                      variant="p3"
                                      className={cx(styles['label--title'], checkboxTitleClass, {
                                          [styles['label--disabled']]: disabled,
                                      })}
                                  >
                                      {title}
                                  </Typography>
                                  {subTitle && (
                                      <Typography
                                          variant="p4"
                                          className={styles['label--subtitle']}
                                      >
                                          {subTitle}
                                      </Typography>
                                  )}
                              </div>
                          )}
                </label>
            </div>
        );
    },
);

export default Checkbox;
